module.exports = __webpack_public_path__ + "img/raseborgs-slottsruiner-skog.3c778b7d.jpg";